import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./Button.module.scss";

const btnCls = "Wfui-button";

const Button = forwardRef(function Button(
  { children, text, icon, isGhost, variant, iconBtnSize, activated, classes, other },
  ref
) {
  const iconBtn = !!icon && !text;

  const onlyIconCls = iconBtn && classnames(styles[iconBtnSize], styles.onlyIcon);
  const activatedCls = activated && styles.activated;
  const ghostCls = isGhost && styles.ghost;

  const buttonClasses = classnames(btnCls, onlyIconCls, ghostCls, activatedCls, styles[variant]);

  const renderIcon = () => {
    return icon ? <span className={`${styles.icon} ${icon}`} /> : null;
  };

  return (
    <button type="button" ref={ref} className={classnames(buttonClasses, classes)} {...other}>
      {children || (
        <>
          {renderIcon()}
          {text && <span>{text}</span>}
        </>
      )}
    </button>
  );
});

Button.displayName = "Button";

Button.defaultProps = {
  isGhost: false,
  variant: "primary",
  other: {},
  iconBtnSize: "medium",
  text: null,
  icon: null,
  activated: false,
  classes: "",
  children: null
};

Button.propTypes = {
  /** if the button is ghost */
  isGhost: PropTypes.bool,
  /** Variant of button. Values: primary, secondary */
  variant: PropTypes.string,
  /** Accepts additional valid HTML attirubutes */
  other: PropTypes.object,
  /** Size of the icon button. Values: small, medium */
  iconBtnSize: PropTypes.string,
  /** Font icon from the left. Accepts font classname as value */
  icon: PropTypes.string,
  /** Button text */
  text: PropTypes.node,
  /** Indicates whether the button should stay in pressed mode. Like 'open' state styling on open/close functionality */
  activated: PropTypes.bool,
  /** Provide additional classes to the Button */
  classes: PropTypes.string,
  /** Provide children to button. If children are provided, it will override the default behaviour */
  children: PropTypes.node
};

export default Button;
